import styles from "../styles/LocalProjectAddonBanner.module.scss";

export const LocalProjectInfoUS = () => (
  <div className={styles.moreInfoCopy}>
    <p>
      Increase your impact by planting extra trees in US soil. Your contribution
      will fund reforestation projects from New York state, all the way to
      Alabama and Georgia.
    </p>
    <ul>
      <li>Plant trees across Appalachia</li>
      <li>Return mining, logging, and agricultural land to balance</li>
      <li>Updates and news from the projects</li>
    </ul>
  </div>
);
